import { useState } from "react";

import Active from "./Active";
import Archive from "./Archive";

const Services = () => {
  const [tab, setTab] = useState("Active");

  const handleTabClick = (nextTab) => {
    setTab(nextTab);
  };

  return (
    <div>
      <div className="flex items-center">
        <span
          onClick={() => handleTabClick("Active")}
          className={`cursor-pointer font-OpenSansRegular text-[14px] font-[600] px-4 ${
            tab === "Active" ? "text-blueColor" : "text-subTitleColor"
          }`}
        >
          Active
        </span>
        <div className="h-4 w-[1px] bg-borderColor"></div>
        <span
          onClick={() => handleTabClick("Archived")}
          className={`cursor-pointer font-OpenSansRegular text-[14px] font-[600] px-4 ${
            tab === "Archived" ? "text-blueColor" : "text-subTitleColor"
          }`}
        >
          Archived
        </span>
      </div>
      {tab === "Active" ? (
        <Active />
      ) : (
        <Archive />
      )}
    </div>
  );
};

export default Services;
